import { queryOptions, useQuery } from '@tanstack/react-query'
import { apiClient } from '~/lib/api-client'
import { CACHE_CONFIG } from '~/lib/cache-config'

export async function fetchShopDetail(shopId: string, locale: string) {
  const res = await apiClient.shops['with-translation'][':id'][':locale'].$get({
    param: { id: shopId, locale },
  })
  if (!res.ok) {
    throw new Error(`Failed to fetch shop ${shopId}: ${res.status}`)
  }
  return res.json()
}

export function shopDetailQueryOptions(shopId: string, locale: string) {
  return queryOptions({
    queryKey: ['shop-detail', shopId, locale],
    queryFn: () => fetchShopDetail(shopId, locale),
    staleTime: CACHE_CONFIG.reference.staleTime,
    gcTime: CACHE_CONFIG.reference.gcTime,
    enabled: !!shopId,
  })
}

export function useShopDetail(
  shopId: string,
  locale: string,
  options?: { enabled?: boolean }
) {
  return useQuery({
    ...shopDetailQueryOptions(shopId, locale),
    enabled: (options?.enabled ?? true) && !!shopId,
  })
}

